<template>
    <div>
        <v-navigation-drawer app
                             justified tabs>
            <b-nav-item active>Dashboard</b-nav-item>
            <b-nav-item>Required Documents</b-nav-item>
            <b-nav-item>Schedule</b-nav-item>
            <b-nav-item>Notes</b-nav-item>
        </v-navigation-drawer>
        <br>
        <router-view></router-view>
    </div>
</template>

<script>
    export default {
        name: "appContainer"
    }
</script>

<style scoped>

</style>